import Chart from "react-apexcharts";
import { useSelector } from "react-redux";
import { RootState } from "shared/redux/store";
import "./BSAOutputDetails.scss";

interface IBSAOutputDetailsChart {
  monthlyCreditDebitChart: any;
}

const BSAOutputDetailsChart: React.FC<IBSAOutputDetailsChart> = (
  props: IBSAOutputDetailsChart
) => {
  const { monthlyCreditDebitChart } = props;

  const { isMobile }: any = useSelector((state: RootState) => state.common);

  const serieList = monthlyCreditDebitChart?.data?.map((data: any) => {
    if (data?.name == "Credit") {
      return { ...data, color: "#20A74E" };
    } else if (data?.name == "Debit") {
      return { ...data, color: "#E12121" };
    }
    return data ?? {};
  });

  const state: any = {
    series: serieList,
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: { show: false },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          borderRadius: 5,
          borderRadiusApplication: "end",
        },
      },
      grid: {
        borderColor: "#DFE5EE",
        strokeDashArray: 7,
      },
      legend: {
        position: "top",
        horizontalAlign: isMobile ? "left" : "right",
        floating: !isMobile,
        offsetY: isMobile ? 0 : -35,
      },
      dataLabels: { enabled: false },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: monthlyCreditDebitChart?.months,
      },
      fill: { opacity: 1 },
      title: { text: "Monthly Credit-Debit Analysis" },
      tooltip: {
        y: {
          formatter: function (val) {
            return "Rs. " + val;
          },
        },
      },
    },
  };

  const dynamicWidth = 9 * 100;
  const chartWidth = dynamicWidth < window.innerWidth ? "100%" : dynamicWidth;

  return (
    <div style={{ marginTop: "20px", overflow: "auto" }}>
      <Chart
        options={state.options}
        series={state.series}
        type="bar"
        height={320}
        width={chartWidth}
      />
    </div>
  );
};

export default BSAOutputDetailsChart;
